

/*------------------------------------------------------------------------------------

JS INDEX
=============
01 - Radio Button Js
02 - Mobile Menu JS
03 - Tab Responsive JS
04 - Back To Top

-------------------------------------------------------------------------------------*/

(function ($) {
	"use strict";

	jQuery(document).ready(function ($) {
		/*
		=================================================================
		01 - Radio Button Js
		=================================================================
		*/

		$('#other-field').focus(function () {
			$('#other').prop("checked", true);
		});

		/*
		=================================================================
		02 - Mobile Menu JS
		=================================================================
		*/
		$(".mainmenu ul li:has(ul)").addClass("has-submenu");
		$(".mainmenu ul li:has(ul.small-dropdown)").addClass("small-submenu");
		$(".mainmenu ul li ul").addClass("sub-menu");
		$(".mainmenu ul.dropdown li").hover(function () {
			$(this).addClass("hover")
		}, function () {
			$(this).removeClass("hover")
		});

		var $menu = $("#menu"),
			$menulink = $("#spinner-form"),
			$menuTriggercont = $(".spinner-master"),
			$menuTrigger = $(".has-submenu > a");
		  $menulink.click(function (e) {
			$menulink.toggleClass("active");
			$menu.toggleClass("active");
			$menuTriggercont.toggleClass("active");
		});

		$menuTrigger.click(function (e) {
			e.preventDefault();
			var t = $(this);
			t.toggleClass("active").next("ul").toggleClass("active")
		});

		$(".mainmenu ul li:has(ul)");

		/*
		=================================================================
		03 - Tab Responsive JS
		=================================================================
		*/
		$.fn.tabConvert = function (options) {

			var settings = $.extend({
				activeClass: "active",
				screenSize: 575,
			}, options);

			return this.each(function (i) {
				var wrap = $(this).wrap('<div class="tab-to-dropdown"></div>'),
					currentItem = $(this),
					container = $(this).closest('.tab-to-dropdown'),
					value = $(this).find('.' + settings.activeClass).text(),
					toggler = '<div class="selected-tab">' + value + '</div>';
				currentItem.addClass('converted-tab');
				container.prepend(toggler);

				function tabConvert_toggle() {
					currentItem.parent().find('.converted-tab').slideToggle();
				}

				container.find('.selected-tab').click(function () {
					tabConvert_toggle();
				});

				currentItem.find('a').click(function (e) {
					var windowWidth = window.innerWidth;
					if (settings.screenSize >= windowWidth) {
						tabConvert_toggle();
						var selected_text = $(this).text();
						$(this).closest('.tab-to-dropdown').find('.selected-tab').text(selected_text);
					}
				});

				function resize_function() {
					var windowWidth = window.innerWidth;
					if (settings.screenSize >= windowWidth) {
						currentItem.css('display', 'none');
						currentItem.parent().find('.selected-tab').css('display', '');
					} else {
						currentItem.css('display', '');
						currentItem.parent().find('.selected-tab').css('display', 'none');
					}
				}
				resize_function();

				$(window).resize(function () {
					resize_function();
				});

			});
		};

		$('.tabs').tabConvert({
			activeClass: "selected",
		});

		$('.menu_nav .nav-tabs').tabConvert({
			activeClass: "active",
			screenSize: 767,
		});

		/*
		=================================================================
		04 - Back To Top
		=================================================================
		*/
		if ($("body").length) {
			var btnUp = $('<div/>', {
				'class': 'btntoTop'
			});
			btnUp.appendTo('body');
			$(document).on('click', '.btntoTop', function () {
				$('html, body').animate({
					scrollTop: 0
				}, 700);
			});
			$(window).on('scroll', function () {
				if ($(this).scrollTop() > 200) $('.btntoTop').addClass('active');
				else $('.btntoTop').removeClass('active');
			});
		}

	});

}(jQuery));



// WEBPACK FOOTER //
// ./src/directives/themeMain.js